import RosterBackendService from './RosterBackendService';
import { LocationDTO, SiteDTO } from '@beable/roster-backend-client-v1';


async function getLocations(): Promise<LocationDTO[]> {
    const response = await RosterBackendService.getLocations();
    if (response.isOk()) {
        return response.value;
    }

    return [];
}

async function getSites(): Promise<SiteDTO[]> {
    const response = await RosterBackendService.getAllSites();
    if (response.isOk()) {
        return response.value;
    }

    return [];
}

async function findSiteBySubdomain(subdomain: string): Promise<SiteDTO | undefined> {
    const response = await RosterBackendService.findSiteBySubdomain(subdomain);
    if (response.isOk()) {
        return response.value;
    }
    return undefined;
}

async function findSiteById(id: number): Promise<SiteDTO | undefined> {
    const response = await RosterBackendService.getSiteById(id);
    if (response.isOk()) {
        return response.value;
    }
    return undefined;
}


export default {
    getLocations, getSites, findSiteBySubdomain, findSiteById
}
